import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import notFound from '../../../../static/images/not_found.png';
import ErrorScreen from './ErrorScreen';

const useStyles = makeStyles(() =>
  createStyles({
    image: {
      width: '100%',
      maxWidth: 180
    }
  })
);

const NotFoundScreen: React.FC<{}> = () => {
  const styles = useStyles({});

  return (
    <ErrorScreen
      visual={<img className={styles.image} src={notFound} alt={'not found'} />}
      title={'ページが見つかりません'}
      description={'お探しのページは変更または削除された可能性があります。'}
    />
  );
};

export default NotFoundScreen;
